import { Component, OnInit, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import { LocationService } from "../../../services/location.service";
import { Countries } from "../../../models/countries";
import { Inventory } from "../../../models/inventory";
import { Methods } from "../../../shared/methods";

@Component({
  selector: "app-bulk-container-inventory",
  templateUrl: "./bulk-container-inventory.component.html",
  styleUrls: ["./bulk-container-inventory.component.css"],
})
export class BulkContainerInventoryComponent implements OnInit {
  public loading = false;
  public saving = false;
  public mtds: Methods = new Methods();  
  public containerName;

  public identity;
  public token;

  constructor(
    private _locationService: LocationService,
    private _service: PrincipalinventoryService,
    private _router: Router,
    public dialogRef: MatDialogRef<BulkContainerInventoryComponent>,
    @Inject(MAT_DIALOG_DATA) public id: number
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    console.log(this.identity);
    this.token = JSON.parse(localStorage.getItem("token"));
  }

  ngOnInit() {    
    this.getContainers();
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  public loadingContainers = false;
  public containers = [];

  getContainers() {
    this.loadingContainers = true;
    this._locationService.getContainersInput(this.token).subscribe(
      (r) => {
        console.log(r);
        this.loadingContainers = false;
        this.containers = r.data.map( element => {
          return {
            id: element.id,
            name: `${element.id} - ${element.item} - ${
              element.internalLocation !== null ? element.internalLocation : ''
            }`
            /*name: `${element.id} - ${element.item} - ${
              element.internalLocation !== null ? element.internalLocation.locationName  + ': ' + element.internalLocation.locationRow + ' - ' +
              element.internalLocation.locationBay + ' - ' + element.internalLocation.locationLevel + ' - ' + element.internalLocation.locationSection : ''
            }`*/
          }
        })

      }, error => {
        this.loadingContainers = false;
      }
    );
  }

  saveContainer(e) {
    console.log(e);
    this.dialogRef.close(e.id);
  }

}
